import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import AddExamAttachmentDialog from "./add-exam-attachment-dialog.vue";
import { ref } from "vue";
import { OnlineAnswersheetAttachment } from "@/composables/online-answersheet/use-online-answersheet-attachments";
import { MessageBox } from "element-ui";

import TrashIcon from "@/assets/icons/svg/trash-icon.svg";
import PaperClipIcon from "@/assets/icons/svg/paper-clip.icon.svg";

//TODO: This version of filesize is very old, consider doing an major update to filesize in a separate issue!
//@ts-ignore
import fileSize from "filesize";
import Examination from "@/interfaces/examination.interface";
import useHttpRequest from "@/composables/use-http-request";


export default /*#__PURE__*/_defineComponent({
  __name: 'examination-attachments-dialog',
  props: {
    isVisible: { type: Boolean },
    attachments: null,
    examination: null,
    onClose: null
  },
  emits: {
  "attachment-added": (attachment: OnlineAnswersheetAttachment) => !!attachment,
  "attachment-removed": (id: string) => !!id,
},
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  attachments: OnlineAnswersheetAttachment[];
  examination: Examination | null;
  onClose: () => void;
}



const closeDialog = () => {
  props.onClose();
};



const addAttachmentDialogVisible = ref(false);
const onAttachFileIntent = () => {
  closeDialog();
  addAttachmentDialogVisible.value = true;
};

const onAttachmentAdded = (attachment: OnlineAnswersheetAttachment) => {
  emit("attachment-added", attachment);
};

const onRemoveAttachment = async (id: string) => {
  try {
    await MessageBox.confirm(
      "Are you sure you want to remove this attachment?",
      "Remove Attachment",
      {
        // eslint-disable-line no-unreachable
        confirmButtonText: "Yes Remove",
        cancelButtonText: "Cancel",
        confirmButtonClass: "el-confirm-btn-danger",
        type: "warning",
      }
    );

    const examSubmission =
      props.examination?.student_examination_submissions?.[0];

    const deleted = await useHttpRequest<{
      success: boolean;
      message: string;
    }>({
      method: "DELETE",
      url: `examinations/attachments/delete-one?student_examination_submission_id=${examSubmission?.student_examination_submission_id}&uuid=${id}`,
      loadingProperty: null,
      showSuccessMessage: false,
      errorLoadingProperty: null,
      showFullScreenLoader: true,
    });

    if (!deleted) {
      return;
    }

    if (
      deleted.success &&
      deleted.message == "Attachment deleted successfully"
    ) {
      emit("attachment-removed", id);
    }
  } catch (error) {
    //No need to do anything
  }
};

return { __sfc: true,props, closeDialog, emit, addAttachmentDialogVisible, onAttachFileIntent, onAttachmentAdded, onRemoveAttachment, BaseDialog, AddExamAttachmentDialog, TrashIcon, PaperClipIcon, fileSize }
}

})